<template>
<div>

    <v-card class="ma-2" v-if="vendorId === -999">
      <v-card-title class="red--text">Input Data Pribadi terlebih dahulu</v-card-title>
    </v-card>

    <PersonPengalamanContent v-else :vendorId="vendorId" />

</div>
</template>


<script>

import PersonPengalamanContent from "./PersonPengalamanContent"


export default {
    components: {
        PersonPengalamanContent
    },

    computed: {
        vendorId() {
            return this.$store.getters['ven/venId'];
        },

    }, // computed
    
}

</script>
